import React from "react";
import { RegisteredUserFlowFormData } from "../MergeLinkModalRoot";
import {
  LinkedAccountFormData,
  LinkingFlowPageEnum,
  NextPagePayloadInfo,
  RegisteredUserFormData,
} from "../../config/types";

const noop = () => {};
export interface AgentHandlerLinkModalContextState {
  apiBaseURL: string;
  linkToken: string;
  allowNavigateToPreviousEntryInHistory: boolean;
  navigateToPreviousEntryInHistory: (linkedAccountFormData?: LinkedAccountFormData, registeredUserFormData?: RegisteredUserFormData) => void;
  getNextPageAndSetPage: (formData: RegisteredUserFlowFormData) => void;
  setIsWaitingForReopenConfirmation: (isWaitingForReopenConfirmation: boolean) => void;
  isLinkOpen: boolean;
  onExit: (shouldOpenFilePicker?: boolean) => void;
  setLinkedAccountID: (linkedAccountID: string) => void;
  findPreviousPagePayloadInHistory: (
    pageToFind: LinkingFlowPageEnum
  ) => NextPagePayloadInfo | undefined;
  shouldHideMergeLogo: boolean;
  shouldShowPoweredByMerge: boolean;
  isLinkTAndCHidden: boolean;
  modalSize: "sm" | "lg";
  setModalSize: React.Dispatch<React.SetStateAction<"sm" | "lg">>;
  modalBorderRadius: string | null;
  coBrandingLogo: string | null;
  translate: (keyString: string, fallbackString: string) => string;
}

const AgentHandlerLinkModalContext = React.createContext<AgentHandlerLinkModalContextState>({
  apiBaseURL: "",
  linkToken: "",
  allowNavigateToPreviousEntryInHistory: false,
  navigateToPreviousEntryInHistory: noop,
  getNextPageAndSetPage: noop,
  setIsWaitingForReopenConfirmation: noop,
  isLinkOpen: false,
  onExit: noop,
  setLinkedAccountID: noop,
  findPreviousPagePayloadInHistory: () => undefined,
  shouldHideMergeLogo: false,
  shouldShowPoweredByMerge: false,
  isLinkTAndCHidden: false,
  modalSize: "sm",
  setModalSize: noop,
  modalBorderRadius: null,
  coBrandingLogo: null,
  translate: (_keyString: string, _fallbackString: string) => "",
});

export default AgentHandlerLinkModalContext;
